import template from './TheSubHeader.html';

export default {
	template,
	computed: {
		activeOwner() {
			return this.owners.find(o => {
				return o.id === this.app.owner;
			}) || {};
		},
		owners() {
			if (!this.app.user) return [];

			let list = this.app.user.sharers.map(sh => {
				return {
					id: sh.id,
					text: sh.email
				};
			});
			list.unshift({
				id: null,
				text: this.ii('ME')
			});
			return list;
		},
		activeTimezone() {
			return this.timezones.find(tz => {
				return tz.zone.name === this.app.tz;
			});
		},
		timezones() {
			let ts = Date.now();
			let list = [
				'UTC',
				'Pacific/Midway',
				'Pacific/Honolulu',
				'Pacific/Tahiti',
				'America/Anchorage',
				'America/Los_Angeles',
				'America/Denver',
				'America/Chicago',
				'America/New_York',
				'America/Halifax',
				'America/Argentina/Buenos_Aires',
				'America/Sao_Paulo',
				'Atlantic/Azores',
				'Europe/London',
				'Europe/Berlin',
				'Europe/Helsinki',
				'Europe/Kiev',
				'Europe/Istanbul',
				'Europe/Moscow',
				'Asia/Dubai',
				'Asia/Kabul',
				'Indian/Maldives',
				'Asia/Calcutta',
				'Asia/Kathmandu',
				'Asia/Dhaka',
				'Indian/Cocos',
				'Asia/Bangkok',
				'Asia/Hong_Kong',
				'Asia/Pyongyang',
				'Asia/Tokyo',
				'Australia/Darwin',
				'Australia/Brisbane',
				'Australia/Adelaide',
				'Australia/Sydney',
				'Pacific/Nauru',
				'Pacific/Auckland',
				'Pacific/Kiritimati'
			];
			let localTz = moment.tz.guess();
			if (localTz && list.indexOf(localTz) === -1) {
				list.push(localTz);
			}

			let names = moment.tz.names();
			return names.map(tz => {
				let zone = moment.tz.zone(tz);
				return {
					name: zone.name,
					offset: zone.utcOffset(ts)
				};
			}).filter(zone => {
				if (zone.name.indexOf('Etc/') === 0) return false;
				if (list.indexOf(zone.name) === -1) return false;
				return true;
			}).sort((a, b) => {
				if (a.offset < b.offset) return 1;
				if (a.offset > b.offset) return -1;

				if (a.name > b.name) return 1;
				if (a.name < b.name) return -1;

				return 0;
			}).map(zone => {
				let offset = zone.offset;
				let sign = '';
				if (offset < 0) {
					sign = '+';
					offset = -offset;
				} else if (offset > 0) {
					sign = '-';
				}

				let hours = Math.floor(offset / 60);
				if (hours < 10) {
					hours = '0' + hours;
				}
				let min = Math.floor(offset % 60);
				if (min < 10) {
					min = '0' + min;
				}
				let time = sign + hours + ':' + min;

				let text = '(UTC ' + time + ') ' + zone.name.replace(/_/g, ' ');

				return {
					text,
					zone,
					isLocal: (zone.name === localTz)
				};
			});
		}
	},
	methods: {
		onTzChange(e) {
			let tz = e.item.zone.name;
			this.app.setTz(tz);

			this.$refs.tzPicker.close();
		},
		onOwnerChange(e) {
			this.app.setOwner(e.item.id);
			this.$refs.ownerPicker.close();
		}
	}
}